<div class="flex w-full flex-col gap-1 p-4 animate-fade-in">
  <app-header
    title="Integrations"
    searchPlaceholder="Search integrations..."
    [newButtonTooltip]="activeTab === 'systems' ? 'New System' : activeTab === 'api-clients' ? 'New API Client' : 'New Field'"
    [showFilter]="false"
    [showNew]="true"
    (onSearch)="handleSearch($event)"
    (onNewClick)="handleNew()"
  ></app-header>

  <div class="integrations-tabs">
    <p-tabs [value]="activeTab" (valueChange)="onTabChange($event)">
      <p-tablist>
        <p-tab value="systems">
          <i class="pi pi-server mr-2"></i>
          Systems
        </p-tab>
        <p-tab value="fields">
          <i class="pi pi-list-check mr-2"></i>
          Fields
        </p-tab>
        <p-tab value="api-clients">
          <i class="pi pi-key mr-2"></i>
          API Clients
        </p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-tabpanel value="systems">
          <app-table
            [allData]="filteredSystems"
            [columns]="systemColumns"
            [actions]="systemActions"
            [totalRecords]="filteredSystems.length"
            [loading]="loadingSystems"
            [rows]="10"
            [rowsPerPageOptions]="[10, 20, 50]"
          ></app-table>
        </p-tabpanel>

        <p-tabpanel value="fields">
          <div class="mb-4 grid grid-cols-1 gap-3 md:grid-cols-3">
            <label class="flex flex-col gap-1 text-xs font-bold uppercase text-gray-500">
              System
              <select
                class="min-h-10 rounded-lg border border-gray-200 bg-white px-3 text-sm font-normal normal-case text-gray-700 outline-none focus:border-[var(--primary-500)] focus:ring-1 focus:ring-[var(--primary-500)]"
                [(ngModel)]="selectedSystemCode"
                (change)="loadFields()"
              >
                <option value="">All systems</option>
                <option *ngFor="let system of systems" [value]="system.code">
                  {{ formatSystemOption(system) }}
                </option>
              </select>
            </label>

            <label class="flex flex-col gap-1 text-xs font-bold uppercase text-gray-500">
              Entity
              <select
                class="min-h-10 rounded-lg border border-gray-200 bg-white px-3 text-sm font-normal normal-case text-gray-700 outline-none focus:border-[var(--primary-500)] focus:ring-1 focus:ring-[var(--primary-500)]"
                [(ngModel)]="selectedEntityType"
                (change)="loadFields()"
              >
                <option value="">All entities</option>
                <option *ngFor="let entityType of entityTypes" [value]="entityType.code">
                  {{ entityType.displayName }}
                </option>
              </select>
            </label>
          </div>

          <app-table
            [allData]="filteredFields"
            [columns]="fieldColumns"
            [actions]="fieldActions"
            [totalRecords]="filteredFields.length"
            [loading]="loadingFields"
            [rows]="10"
            [rowsPerPageOptions]="[10, 20, 50]"
          ></app-table>
        </p-tabpanel>

        <p-tabpanel value="api-clients">
          <app-table
            [allData]="filteredApiClients"
            [columns]="apiClientColumns"
            [actions]="apiClientActions"
            [totalRecords]="filteredApiClients.length"
            [loading]="loadingApiClients"
            [rows]="10"
            [rowsPerPageOptions]="[10, 20, 50]"
          ></app-table>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
